import { BannerType, MockControlState } from '../../types';

const MOCK_STATE_TO_BANNER_MAP: Record<MockControlState, BannerType> = {
  [MockControlState.EXPIRING_SOON]: BannerType.COUNTDOWN,
  [MockControlState.UNAVAILABLE]: BannerType.BLOCKED,
  [MockControlState.AVAILABLE]: BannerType.WARNING
};

export const getBannerType = (
  mockInitiateState?: MockControlState,
  mockInitiateMessage?: string | null
): BannerType => {
  if (!mockInitiateMessage || !mockInitiateState) {
    return BannerType.NONE;
  }

  return MOCK_STATE_TO_BANNER_MAP[mockInitiateState] ?? BannerType.NONE;
};
